import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlxLayoutModule } from '@fluxys/gsmart/layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import {
  MessageSettingsClient,
  CodeTranslationsClient,
  MessagesClient,
  CommunicationProfilesClient,
  PartnersClient,
  EntsogClient,
  TenantsClient,
  SecretsClient,
  EntsogCommunicationProfileClient,
  CoreDataClient
} from "./shared/api/clients";
import { ValidationErrorInterceptorService } from "./core/services/validation-error-interceptor.service";
import { FlxLoadingSpinnerComponent } from "@fluxys/primeng";
import { UnauthorizedErrorInterceptorService } from "./core/services/unauthorized-error-interceptor.service";

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FlxLayoutModule,
    FlxLoadingSpinnerComponent,
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: ValidationErrorInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedErrorInterceptorService, multi: true },
    DatePipe,
    MessageSettingsClient,
    CoreDataClient,
    CodeTranslationsClient,
    MessagesClient,
    CommunicationProfilesClient,
    PartnersClient,
    EntsogClient,
    TenantsClient,
    SecretsClient,
    EntsogCommunicationProfileClient
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
